// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Nxoy","controls":"styles_controls__19eMp","charLimit":"styles_charLimit__1TSRg","input":"styles_input__3s8Pv","send":"styles_send__2UhAX"};